/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Note_Col_CodeInputs */

const vi_sl_note_col_code = /** @type {(inputs: Sl_Note_Col_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã phiếu`)
};

/**

* @param {Sl_Note_Col_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_note_col_code = /** @type {((inputs?: Sl_Note_Col_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Note_Col_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_note_col_code(inputs)
});